export default "__VITE_ASSET__DoDXgNhr__"